export const optionsPriority = [
    { label: 'BAIXA', value: 0 },
    { label: 'MÉDIO', value: 1 },
    { label: 'ALTA', value: 2 },
    { label: 'URGENTE', value: 3 },
]

export const priorityMap = {
    BAIXA: { value: 'green', label: 'Baixa' },
    MEDIA: { value: 'yellow', label: 'Média' },
    ALTA: { value: 'red', label: 'Alta' },
    URGENTE: { value: 'red', label: 'Urgente' },
};

export const statusMap = {
    ESCALADO: { value: 'execucao', label: 'Escalado' },
    RESOLVIDO: { value: 'resolvido', label: 'Resolvido' },
    EXECUCAO: { value: 'execucao', label: 'Em Execução' },
    ABERTO: { value: 'aberto', label: 'Pendente' },
    CANCELADO: { value: 'cancelado', label: 'Cancelado' },
};

export const ratingOption = [
    { label: 'Ruim', value: 0 },
    { label: 'Regular', value: 1 },
    { label: 'Bom', value: 2 },
    { label: 'Excelente', value: 3 },
]